// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cBiQjvvFPYYjrYvHEKz0{flex:none;justify-content:space-between;margin-bottom:24px;display:flex}.w8sE3eI4CVUu6Dc49hTx{justify-content:center;align-items:center;gap:8px;display:flex}.QbUywPTtCb8EsutLXsM0{display:none}.lw2_ntTDouMqvMXYCed5{align-items:center;display:flex}.Qq68EvIuWPwO7kWiHfLO{width:400px}.FwXU0NLxXf8XpFFHgiTE{padding-left:12px}.M5y899fNIUE2tgCkNUSJ{width:296px}.w3K6MTEhplYNWfCpl0ZF{background-color:var(--gray-30);width:1px;height:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"controls": `cBiQjvvFPYYjrYvHEKz0`,
	"buttonsGroup": `w8sE3eI4CVUu6Dc49hTx`,
	"fileInput": `QbUywPTtCb8EsutLXsM0`,
	"textInput": `lw2_ntTDouMqvMXYCed5`,
	"uploadViaUrl": `Qq68EvIuWPwO7kWiHfLO`,
	"textFieldIndent": `FwXU0NLxXf8XpFFHgiTE`,
	"search": `M5y899fNIUE2tgCkNUSJ`,
	"divider": `w3K6MTEhplYNWfCpl0ZF`
};
export default ___CSS_LOADER_EXPORT___;
